import { resolveApiBaseUrl } from '@/utils/apiBase';

const getApiBaseUrl = () => resolveApiBaseUrl();

interface FrontendLogPayload {
  level?: 'info' | 'warn' | 'error';
  message: string;
  stack?: string;
  context?: unknown;
}

export const logFrontendError = async (payload: FrontendLogPayload) => {
  try {
    await fetch(`${getApiBaseUrl()}/public/logs/frontend`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
      credentials: 'include',
    });
  } catch (error) {
    console.error('[logger] Failed to send frontend log', error);
  }
};

export const logFrontendInfo = (message: string, context?: unknown) =>
  logFrontendError({ level: 'info', message, context });

export const logFrontendWarn = (message: string, context?: unknown) =>
  logFrontendError({ level: 'warn', message, context });
